import "./Navbar.scss"

const Navbar = ({buttons}) => {
    return (
        <div className="buttons">
            {
               buttons.map(item=>( 
                    <button>{item}</button>
                ))   
            }
        </div>
    );
};

export default Navbar;

